var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.019,
    height: 13.842,
    viewBox: "0 0 17.019 13.842",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M13.593,6.609h0a.72.72,0,0,0-.008,1.025l4.955,4.973H4.721A.721.721,0,0,0,4,13.328H4a.721.721,0,0,0,.721.721H18.54L13.581,19a.721.721,0,0,0,0,1.02l.012.012a.721.721,0,0,0,1.019,0l6.2-6.2a.722.722,0,0,0,0-1.02l-6.2-6.2A.72.72,0,0,0,13.593,6.609Z",
    transform: "translate(-4 -6.404)",
    fill: "#4a4a4a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.e0eb2c77a1affc60ddee3fd4eb7c1aaf.svg";
export { ForwardRef as ReactComponent };